import { render, staticRenderFns } from "./AdManCus.vue?vue&type=template&id=21cbc7b1&scoped=true"
import script from "./AdManCus.vue?vue&type=script&lang=js"
export * from "./AdManCus.vue?vue&type=script&lang=js"
import style0 from "./AdManCus.vue?vue&type=style&index=0&id=21cbc7b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbc7b1",
  null
  
)

export default component.exports